import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n<path d=\"M50 450L450 50\" stroke=\"currentColor\" stroke-width=\"37.7124\" />\n<path d=\"M450 450L50 50\" stroke=\"currentColor\" stroke-width=\"37.7124\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol